import {ApplicationRef, Component, ViewEncapsulation} from '@angular/core';
import {SelectionItemDto} from '../../../dto/SelectionItemDto';
import {CommunicationService} from '../../../service/communication.service';
import {ResponseDtoType} from '../../../dto/ResponseDtoType';
import {ImmediatelyRenderedMessageComponent} from '../immediately-rendered-message-component';

interface MultipleItem {
    id: string;
    text: string;
}

@Component({
    templateUrl: './multi-selection-list-message.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MultiSelectionListMessageComponent extends ImmediatelyRenderedMessageComponent {

    public static TYPE: ResponseDtoType = 'multiselectionlist';
    public chosenMultipleItems: MultipleItem[] = [];

    constructor(private communicationService: CommunicationService,
                private applicationRef: ApplicationRef) {
        super();
    }

    public selectItem(chosenItem: SelectionItemDto): void {
        chosenItem.selected = !chosenItem.selected;
        this.applicationRef.tick();
    }

    public async sendSelectItems(items: SelectionItemDto[]): Promise<void> {
        // Data can be any

        this.message.data.responseItemData.selectionInactive = true;
        // Data can be any

        this.message.data.responseItemData.hideSelectionButton = true;
        items.forEach(item => {
            if (item.selected) {
                const multiItem: MultipleItem = {
                    id: items.indexOf(item).toString(),
                    text: item.buttonMessage
                };
                this.chosenMultipleItems.push(multiItem);
            }
        });
        // Data can be any

        await this.communicationService.sendEvent(this.message.data.responseItemData.targetEventKey, 'multiselectionlist', this.chosenMultipleItems);
        this.applicationRef.tick();
    }
}
